import { MODAL_TYPE_POST_SETTINGS } from '@wix/communities-blog-client-common';
import { setIsSaving } from '../../../common/store/is-saving/is-saving-actions';

export const modalDataLoaderByType = {
  [MODAL_TYPE_POST_SETTINGS]: () => [setIsSaving(false)],
};
